import { BehaviourDataActionTypes } from '../constants/ApiConstants';

const initialState = {
    loading: false,
    patientRecordRateList: null,
    isStart: false,
    isSave: false,
    secondsElapsed: 0,
    incrementer: [],
    newIncrementer: [],
    save_patientRecordRate: null,
    customRateArray: []
};

export default (state = initialState, { type, payload }) => {
    switch (type) {
        /* Record Rate */  
        case BehaviourDataActionTypes.get_patientRecordRateData.REQUEST:
            return {
                ...state,
                loading: true,
                patientRecordRateList: null
            }
        case BehaviourDataActionTypes.get_patientRecordRateData.SUCCESS:
            return {
                ...state,
                loading: false,
                patientRecordRateList: payload
            }

        case BehaviourDataActionTypes.start_recordRateTimer.SUCCESS:
            return {
                ...state,
                loading: false,
                isStart: payload
            }
        case BehaviourDataActionTypes.start_secondsElapsedForRate.SUCCESS:
            return {
                ...state,
                loading: false,
                secondsElapsed: payload
            }
        case BehaviourDataActionTypes.reset_secondsElapsedForRate.SUCCESS:
            return {
                ...state,
                loading: false,
                secondsElapsed: payload
            }
        case BehaviourDataActionTypes.save_patientRecordRateData.REQUEST:
            return {
                ...state,
                loading: true,
                save_patientRecordRate: null
            }
        case BehaviourDataActionTypes.save_patientRecordRateData.SUCCESS:
            return {
                ...state,
                loading: false,
                save_patientRecordRate: payload
            }
        case BehaviourDataActionTypes.set_customRateArray.SUCCESS:
            return {
                ...state,
                customRateArray: payload
            }
        case BehaviourDataActionTypes.reset_customRateArray.SUCCESS:
            return {
                ...state,
                customRateArray: payload
            }
            
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/BehaviorData/reducers/recordRateCustomReducer.js